var _defs, _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoqalReverseBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    width: 1000,
    height: 1000,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Light Blue BG dark -svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 733.2,
    y1: 404.9,
    x2: 706.5,
    y2: 365.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000000",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x1: 269.1,
    y1: 402.4,
    x2: 294.9,
    y2: 360.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000000",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000000"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #305870 } \n\t\t.s1 { fill: #e6ff0a } \n\t\t.s2 { fill: #a4c3d4 } \n\t\t.s3 { opacity: .3;fill: url(#g1) } \n\t\t.s4 { opacity: .3;fill: url(#g2) } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m0 0h1000v1000h-1000z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m663.7 459.5c5.4-4.9 8.2-7.2 13.7-12-3.7 3.3-8.4 7.2-13.7 12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m758.9 342.5c-1.4-1.3-3.1-1.8-4.8-1.5-31.8 4.8-75.9 26.6-75.9 26.6 0.6-0.3 0.8-0.6 1.4-0.8 0 0-4.7 2.6-7.2 4.1-22.1 13-36.5 24.4-51.3 37.9-38.8 35.2-74.4 74.4-109 113.7-3.4 3.9-7.8 5.8-12.2 5.8-4.4 0-8.8-1.9-12.2-5.8-34.6-39.3-70.2-78.5-109-113.7-14.8-13.5-29.2-24.7-51.3-37.9-2.5-1.5-7.2-4.1-7.2-4.1 0.6 0.2 0.9 0.5 1.4 0.8 0 0-44.1-21.8-75.9-26.6-1.7-0.3-3.4 0.2-4.8 1.5 1.9-2.5 4.4-4.6 7.3-5.7 32.4-12.9 49-18.4 83.1-27.3 26.3-6.7 53.6-7.4 79.2-0.8 13.2 3.3 26 8.6 34.2 15.6 15 12.7 31.5 28.3 45.3 42.7 2.8 2.9 6.3 4.3 9.9 4.2 3.6 0.1 7.1-1.3 9.9-4.2 13.8-14.4 30.5-29.9 45.3-42.7 8.1-7 21-12.2 34.2-15.6 25.6-6.7 52.9-6 79.2 0.8 34.1 8.8 50.7 14.4 83.1 27.3 2.9 1.3 5.4 3.2 7.3 5.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m336.2 459.5c-5.5-4.9-8.3-7.2-13.8-12 3.7 3.3 8.4 7.2 13.8 12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m772.6 451c0 0.4 0 0.6 0 0.9-0.9 34.1-7.2 63.2-26.2 82.2-50.2 50.5-99.9 102-149.3 153.4-20.5 21.4-59.5 2.8-59.9-30.8-0.1-11.9-0.2-22.7-0.4-32-0.2-19.7 6.3-38.3 17.9-51.6 34.4-39.4 70.1-78.3 109.2-113.6 5.5-4.9 8.3-7.2 13.8-12 3.7-3.2 6.4-5.5 8.3-7v-0.2c0.6-0.4 0.9-0.7 1.4-1.1 0.1-0.1 0.4-0.4 0.5-0.5 6-5.1 7.2-13.2 7.3-17.9 0.2-4.5-0.1-13.8-6-23-0.7-1-1.4-1.9-1.9-2.9-0.7-1-1.3-1.9-1.8-2.7q-0.8-1.3-1.7-2.5c-1.8-2.9-3.3-5.5-5-8.3-0.6-0.8-1-1.5-1.6-2.3-1.3-2.5-3-5.1-4.8-8.1q2.9-1.6 5.8-3.3c26.5-14.9 44.1-21.8 75.9-26.6 1.7-0.3 3.4 0.3 4.8 1.5 1.7 1.9 2.9 4.3 3.6 6.7 0.1 0 0.1 0.2 0.1 0.2 3 10.5 5 21.4 6.5 32.2 0.2 1.7 0.5 3.5 0.7 5.1 0.2 1.9 0.4 3.8 0.6 5.8 2.1 19.5 2.8 39.4 2.2 58.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m445.1 572.9c11.6 13.3 18.2 32 17.9 51.6-0.2 9.4-0.3 20.2-0.4 32-0.3 33.6-39.4 52.3-59.9 30.9-49.4-51.5-98.9-102.9-149.3-153.5-18.8-18.9-25.1-48-26.2-82.2q0-0.4 0-0.8c-0.6-18.9 0.2-39 2.3-58.3 0.3-2 0.4-3.9 0.7-5.8 0.1-1.6 0.4-3.4 0.7-5.1 1.5-10.8 3.4-21.7 6.4-32.2 0.2 0 0.2-0.2 0.2-0.2 0.8-2.4 2-4.8 3.5-6.7 1.4-1.2 3.2-1.8 4.8-1.5 31.9 4.8 49.4 11.7 75.9 26.6 1.8 1 3.7 2.2 5.8 3.3-1.8 3.2-3.3 5.6-4.8 8.1-0.4 0.8-0.8 1.5-1.4 2.3-1.6 2.8-3.3 5.4-5.1 8.3q-0.8 1-1.6 2.5c-0.7 0.8-1.1 1.7-1.8 2.7-0.7 0.8-1.2 1.9-1.9 2.9-5.9 9.2-6.2 18.5-6 23 0.1 4.7 1.3 12.8 7.2 17.9 0.2 0.1 0.3 0.4 0.6 0.5 0.5 0.4 0.8 0.7 1.4 1.1 0 0.2 0 0.2 0 0.2 1.9 1.5 4.8 3.9 8.3 7 5.5 4.8 8.3 7.1 13.8 12 38.7 35.5 74.5 74.2 108.9 113.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m769.2 381.6c-28.1 16.3-55.3 35.5-81.3 57.1 6-5.1 7.2-13.2 7.3-17.9 0.2-4.5-0.1-13.8-6-23-0.7-1-1.4-1.9-1.9-2.9-0.7-1-1.3-1.9-1.8-2.7q-0.8-1.3-1.7-2.5c-1.8-2.9-3.3-5.5-5-8.3-0.6-0.8-1-1.5-1.6-2.3-1.3-2.5-3-5.1-4.8-8.1q2.9-1.6 5.8-3.3c26.5-14.9 44.1-21.8 75.9-26.6 1.7-0.3 3.4 0.3 4.8 1.5 1.7 1.9 2.9 4.3 3.6 6.7 0.1 0 0.1 0.2 0.1 0.2 3 10.5 5 21.4 6.6 32.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m237.2 349.5c0 0 0-0.2 0.1-0.2 0.7-2.4 1.9-4.8 3.6-6.7 1.4-1.2 3.1-1.8 4.8-1.5 31.8 4.8 49.4 11.7 75.9 26.6q2.9 1.7 5.8 3.3c-1.8 3-3.5 5.6-4.8 8.1-0.6 0.8-1 1.5-1.4 2.3-1.8 2.8-3.3 5.4-5.1 8.3q-0.8 1.2-1.6 2.5c-0.6 0.8-1.1 1.7-1.8 2.7-0.6 1-1.3 1.9-1.9 2.9-5.9 9.2-6.2 18.5-6.1 23 0.2 4.7 1.4 12.8 7.3 17.9-25.9-21.6-53.1-40.8-81.3-57.1 1.5-10.7 3.5-21.6 6.5-32.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoqalReverseBig);
export default __webpack_public_path__ + "static/media/foqal-reverse-big.b2c4fa0ec2fd71bab7285ad61ef4c7b5.svg";
export { ForwardRef as ReactComponent };